<template>
	<div class="ReportPerformanceCard">
		<div class="heading">
			<h4 class="text-xl text-app-dashboard-heading">
				<!-- Sales performance by location -->
			</h4>
			<!-- <p class="text-sm text-amp-heading2 py-1">
				{{ today }}
			</p> -->
		</div>
		<div class="all-cards">
			<div
				v-for="(data, index) in summaryData"
				:key="'data-data-' + index"
				class="sales-performance-card" 
			>
				
				<div class="card-inner-sec  "> 
					<div class="card-text">
						<span
							class="text-black"
							style="white-space: nowrap; font-size: 14px;font-weight: 600;"
						>
							{{ data.label }}
						</span>

						<i v-if="reportCardLoad" class="el-icon-loading text-lg mt-2" style="color: #e29d5a;"></i>
						<span v-else class="viewers font-bold" style="color: #e29d5a;">
							{{ data.value ? new Intl.NumberFormat().format(data.value) : 0 }}
						</span>
					</div>
				</div> 
			</div>
		</div>
	</div>
</template>

<script>
import { Dates } from "../../../../../mixins/dates.mixin";
import { mapActions, mapState } from "vuex";
import moment from "moment"; 
export default {
	name: "ReportPerformanceCard",
	mixins: [Dates],
	props: [],
	data() {
		return {
			today: moment(
				new Date(new Date().setDate(new Date().getDate() - 1))
			).format("dddd, Do MMMM YYYY"),
			summary: [
				{
					label: "Actual Sales",
					param: "actual_sales",
					value: null
				},
				{
					label: "Projected Transactions",
					param: "projected_transaction",
					value: null
				},
				{
					label: "Actual Transactions",
					param: "actual_transactions",
					value: null
				},
				{
					label: "Scheduled Labor Hours",
					param: "scheduled_labour_hours",
					value: null
				},
				{
					label: "Actual Labor Hours",
					param: "actual_labour_hours",
					value: null
				}, 
				{
					label: "Scheduled Cost",
					param: "scheduled_cost",
					value: null
				}, 
				{
					label: "Actual Cost",
					param: "actual_cost",
					value: null
				}, 
				{
					label: "COL % - Actual",
					param: "actual_cost_percentage",
					value: null
				}, 
			]
		};
	},
	computed: {
		...mapState("CommonStore", ["reportSummaryData", "reportCardLoad"]),

		summaryData(){
			Object.entries(this.summary).map((sm)=>{
				Object.entries(this.reportSummaryData).map((data)=>{ 
					if(data[0] == sm[1].param){ 
						sm[1].value = data[1];
					}
				})
			});
			return this.summary;
		}
	},
	created() {
		this.parseDate();
		this.getPartnerSummaryAction(); 
	},
	methods: {
		...mapActions("CommonStore", ["getPartnerSummaryAction"]),
		parseDate() {
			var currentDate = this.currentDateYYYYMMDD();
			var dayOfWeek = this.getDayOfWeek(currentDate);
			var monthOfYear = this.getMonthOfYear(currentDate);
			var dayOfMonth = this.getDayOfMonth(currentDate);
			var dayOfMonthOrdinal = this.ordinal(dayOfMonth);
			var fullYear = this.getFullYear(currentDate);
			return (
				"Today is " +
				dayOfWeek +
				", " +
				dayOfMonthOrdinal +
				" " +
				monthOfYear +
				" " +
				fullYear
			); 
		}, 
	}
};
</script>

<style lang="scss" scoped>
@import "./ReportPerformanceCard.scss";
// @import "./AppSalesPerformanceCardM.scss";
</style>
